"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _vue = _interopRequireDefault(require("vue"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var bus = new _vue["default"]();
var _default = bus;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/bus.js
// module id = 75
// module chunks = 0